import { render, staticRenderFns } from "./VisaTransferView.vue?vue&type=template&id=51cb4535&"
import script from "./VisaTransferView.vue?vue&type=script&lang=js&"
export * from "./VisaTransferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports